import React from 'react';
import { connect } from 'react-redux'

import { _setAxios, _success, _tableLogActivity, getParamTable, _validationFormMsg, _getBase64Upload, _getBase64 } from '../../lib/Helper';
import { schemaPelatihan } from './schema';
import validate from 'validate.js';
import { pelatihanPenyelenggaraOptions, pelatihanBidangOptions } from '../../data/options';

import { Table, Row, Col, Divider, Popover, Button, Radio, Space, Dropdown, Input, Tooltip, Modal, Upload, message } from 'antd';
import { PageHeader } from 'components/header';
import { SaveOutlined, InfoCircleOutlined, SearchOutlined, EllipsisOutlined, PlusOutlined, SortAscendingOutlined, EditOutlined, DeleteOutlined, ExclamationCircleOutlined, DownloadOutlined, InboxOutlined } from '@ant-design/icons';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import Stack from '@mui/material/Stack';

const { Dragger } = Upload;

const tableOptions = {
    sorts: [{
        value: "ASC",
        label: "Ascending",
    }, {
        value: "DESC",
        label: "Descending",
    }],
    fields: [{
        value: "id",
        label: "Tanggal Pembuatan",
    }, {
        value: "nama",
        label: "Nama",
    }]
}

class Pelatihan extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            values: {},
            errors: {},

            table: {
                loading: false,
                data: [],
                search: "",
                pagination: {
                    current: 1,
                    pageSize: 10,
                    total: 0,
                },
                sorting: [],
                filtering: {},
            },
            form: {
                visible: false,
                loading: false,
            },
            fileList: [],
            validateFile: false
        };
    }

    componentDidMount() {
        this.fetchTable()
    }

    fetchTable = () => {
        const { table } = this.state
        const params = getParamTable("default", table)
        this.fetch(params);
    }

    fetch = async (params = {}) => {
        this.setState({
            table: {
                ...params,
                loading: true
            }
        });
        _setAxios("tk/pelatihan/table/" + this.props.dataID, "POST", params).then(resp => {
            if (resp.status === true) {
                this.setState({
                    table: {
                        ...params,
                        loading: false,
                        data: resp.data.list,
                        pagination: {
                            ...params.pagination,
                            total: resp.data.info.total
                        }
                    }
                });
            } else {
                this.setState({
                    table: {
                        ...params,
                        loading: false,
                    }
                })
            }
        })
    };

    handleChange = (e) => {
        const { values } = this.state;
        const { name, value } = e.target;

        this.setForm(values, name, value)
    };

    handleChangeSetValue = (name, value) => {
        const { values } = this.state;
        this.setForm(values, name, value)
    };

    setForm = (values, name, value) => {
        values[name] = value;

        const errors = validate(values, schemaPelatihan);
        this.setState({
            values: values,
            errors: errors || {},
        });

        return this.setValidate(values)
    }

    setValidate = (values) => {
        const errors = validate(values, schemaPelatihan);
        this.setState({
            values: values,
            errors: errors || {},
        });

        return errors
    }

    hasError = field => {
        return this.state.errors[field] ? true : false;
    }

    // HANDLE FILE START --------------------------------------
    beforeUploadFile = (file) => {
        const isJpgOrPngPdf = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';
        if (!isJpgOrPngPdf) {
            message.error('Anda bisa upload JPG/PNG/PDF file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('File tidak boleh lebih besar dari 2MB!');
        }

        const flag = isJpgOrPngPdf && isLt2M

        if (flag === false) {
            this.setState({
                validateFile: false,
            })
            return false
        } else {
            this.setState({
                validateFile: true,
            })
        }
        return true
    };

    handleChangeFile = ({ fileList }) => {
        if (this.state.validateFile === true) {
            fileList.forEach((row, i) => {
                fileList[i].status = "done"
            });

            this.setState({
                fileList: fileList
            })
        } else {
            this.setState({
                fileList: null
            })
        }
    };
    // HANDLE FILE END --------------------------------------


    // CREATE START ------------------------------------------

    hideModalForm = (row) => {
        this.setState({
            form: {
                ...this.state.form,
                visible: false
            },
            values: {},
            errors: {},
        });
    };

    showModalForm = (row) => {
        if (row.id) {
            this.setState({
                form: {
                    ...this.state.form,
                    visible: true,
                },
                values: {
                    id: row.id ? row.id : null,
                    nama: row.nama ? row.nama : null,
                    bidang: row.bidang ? row.bidang : null,
                    penyelenggara: row.penyelenggara ? row.penyelenggara : null,
                    tahun: row.tahun ? row.tahun : null,
                    tgl_mulai: row.tgl_mulai ? row.tgl_mulai : null,
                    tgl_selesai: row.tgl_selesai ? row.tgl_selesai : null,
                    nomor_sertifikat: row.nomor_sertifikat ? row.nomor_sertifikat : null,
                    tgl_sertifikat: row.tgl_sertifikat ? row.tgl_sertifikat : null,
                },
                fileList: [],
            });
        } else {
            this.setState({
                form: {
                    ...this.state.form,
                    visible: true,
                },
                values: {},
                errors: {},
                fileList: [],
            });
        }
    };

    onSubmitForm = async (e) => {
        e.preventDefault();
        const { values } = this.state

        //Validation 
        let validation = this.setValidate(values, schemaPelatihan)
        if (validation !== undefined) {
            return _validationFormMsg(validation)
        }

        // Tahun & Tanggal
        let tahun = values.tahun
        if (values.tahun && values.tahun instanceof Date) {
            tahun = values.tahun.getFullYear()
        }
        let tglMulai = values.tgl_mulai
        if (values.tgl_mulai && values.tgl_mulai instanceof Date) {
            let tgl = values.tgl_mulai.getDate() <= 9 ? "0" + values.tgl_mulai.getDate() : values.tgl_mulai.getDate()
            let bln = values.tgl_mulai.getMonth() <= 9 ? "0" + values.tgl_mulai.getMonth() : values.tgl_mulai.getMonth()
            let thn = values.tgl_mulai.getFullYear()

            tglMulai = tgl + "-" + bln + "-" + thn
        }
        let tglSelesai = values.tgl_selesai
        if (values.tgl_selesai && values.tgl_selesai instanceof Date) {
            let tgl = values.tgl_selesai.getDate() <= 9 ? "0" + values.tgl_selesai.getDate() : values.tgl_selesai.getDate()
            let bln = values.tgl_selesai.getMonth() <= 9 ? "0" + values.tgl_selesai.getMonth() : values.tgl_selesai.getMonth()
            let thn = values.tgl_selesai.getFullYear()

            tglSelesai = tgl + "-" + bln + "-" + thn
        }
        let tglSertifikat = values.tgl_sertifikat
        if (values.tgl_sertifikat && values.tgl_sertifikat instanceof Date) {
            let tgl = values.tgl_sertifikat.getDate() <= 9 ? "0" + values.tgl_sertifikat.getDate() : values.tgl_sertifikat.getDate()
            let bln = values.tgl_sertifikat.getMonth() <= 9 ? "0" + values.tgl_sertifikat.getMonth() : values.tgl_sertifikat.getMonth()
            let thn = values.tgl_sertifikat.getFullYear()

            tglSertifikat = tgl + "-" + bln + "-" + thn
        }

        // File base64
        let fileList = this.state.fileList
        let file = null
        if (fileList && fileList.length > 0) {
            if (fileList[0].url && (fileList[0].url.includes("https://") || fileList[0].url.includes("http://"))) {
            } else {
                file = await _getBase64(fileList[0].originFileObj)
                file = _getBase64Upload(file)
            }
        }

        // Payload
        const param = {
            nama: values.nama ? values.nama : null,
            bidang: values.bidang ? values.bidang : null,
            penyelenggara: values.penyelenggara ? values.penyelenggara : null,
            tahun: tahun,
            tgl_mulai: tglMulai ? tglMulai : null,
            tgl_selesai: tglSelesai ? tglSelesai : null,
            nomor_sertifikat: values.nomor_sertifikat ? values.nomor_sertifikat : null,
            tgl_sertifikat: tglSertifikat ? tglSertifikat: null,
            file: file
        }

        // Define Network
        let method = "POST"
        let payload = [param]
        let id = this.props.dataID
        if (values.id) {
            method = "PUT"
            payload = param
            id = values.id
        }

        this.setState({
            form: {
                ...this.state.form,
                loading: true
            }
        });
        _setAxios("tk/pelatihan/" + id, method, payload).then(resp => {
            if (resp.status === true) {
                _success('topRight', 'Success', resp.data.message)
                this.hideModalForm()
                this.fetchTable()
            }

            this.setState({
                form: {
                    ...this.state.form,
                    loading: false
                }
            });
        })
    };

    // CREATE END ------------------------------------------


    onDelete = (row) => {
        Modal.confirm({
            title: 'Hapus Data',
            width: 470,
            icon: <ExclamationCircleOutlined />,
            content: <>Data akan dihapus dari list, Apakah Anda Yakin ?</>,
            cancelText: 'Batal',
            okText: 'Simpan',
            onOk: () => {
                return new Promise((resolve, reject) => {
                    _setAxios("tk/pelatihan/" + row.id, "DELETE").then(resp => {
                        if (resp.status === true) {
                            _success('topRight', 'Success', resp.data.message)
                            this.fetchTable()
                        }
                        setTimeout(Math.random() > 0.5 ? resolve : reject, 100);
                    })
                }).catch(() => console.log('Oops errors!'));
            },
            onCancel: () => {
                console.log("No action to process")
            },
        });
    }

    render() {
        const { table, values, errors } = this.state;

        const sortComponent = <>
            <Radio.Group onChange={(e) => {
                const params = getParamTable("sort_field", table, e.target.value)
                this.fetch(params)
            }} value={table.sorting.length > 0 ? table.sorting[0].field : ""} name="sort_field">
                <Space direction="vertical">
                    {tableOptions.fields.map((row, i) => <Radio key={i} value={row.value}>{row.label}</Radio>)}
                </Space>
            </Radio.Group>
            <Divider orientation="left"></Divider>
            <Radio.Group onChange={(e) => {
                const params = getParamTable("sort", table, e.target.value)
                this.fetch(params)
            }} value={table.sorting.length > 0 ? table.sorting[0].sort : ""} name="sort_value">
                <Space direction="vertical">
                    {tableOptions.sorts.map((row, i) => <Radio key={i} value={row.value}>{row.label}</Radio>)}
                </Space>
            </Radio.Group>
        </>

        const modalForm = <Modal
            title="Form Pelatihan"
            visible={this.state.form.visible}
            width={700}
            onCancel={this.hideModalForm}
            footer={<>
                <Button onClick={this.hideModalForm}>Batal</Button>
                <Button type="primary" htmlType="submit" onClick={this.onSubmitForm} loading={this.state.form.loading} icon={<SaveOutlined />}>Simpan</Button>
            </>}
        >
            <Row gutter={[16, 16]}>
                <Col xs={14}>
                    <Row gutter={[16, 16]}>
                        <Col xs={24}>
                            <TextField
                                fullWidth
                                label="Nama Pelatihan *"
                                size="small"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                name="nama"
                                type="text"
                                onChange={this.handleChange}
                                value={values.nama || ''}
                                error={this.hasError('nama')}
                                helperText={
                                    this.hasError('nama') ? errors.nama[0] : null
                                }
                            />
                        </Col>
                        <Col xs={24}>
                            <Autocomplete
                                options={pelatihanBidangOptions}
                                renderInput={(params) => <TextField {...params}
                                    fullWidth
                                    label="Bidang *"
                                    size="small"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    name="bidang"
                                    type="text"
                                    error={this.hasError('bidang')}
                                    helperText={
                                        this.hasError('bidang') ? errors.bidang[0] : null
                                    }
                                />}
                                value={values.bidang || null}
                                onChange={(e, newValue) => {
                                    this.handleChangeSetValue("bidang", newValue ? newValue.value : null)
                                }}
                            />
                        </Col>
                        <Col xs={24}>
                            <Autocomplete
                                options={pelatihanPenyelenggaraOptions}
                                value={values.penyelenggara || null}
                                onChange={(e, newValue) => {
                                    this.handleChangeSetValue("penyelenggara", newValue ? newValue.value : null)
                                }}

                                renderInput={(params) => <TextField {...params}
                                    fullWidth
                                    label="Penyelenggara *"
                                    size="small"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    name="penyelenggara"
                                    type="text"
                                    error={this.hasError('penyelenggara')}
                                    helperText={
                                        this.hasError('penyelenggara') ? errors.penyelenggara[0] : null
                                    }
                                />}
                            />
                        </Col>

                        <Col xs={24}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <Stack spacing={3}>
                                    <MobileDatePicker
                                        label="Tahun *"
                                        views={['year']}
                                        value={values.tahun || null}
                                        onChange={(newValue) => {
                                            this.handleChangeSetValue("tahun", newValue)
                                        }}
                                        renderInput={(params) => <TextField
                                            size="small"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            error={this.hasError('tahun')}
                                            helperText={
                                                this.hasError('tahun') ? errors.tahun[0] : null
                                            }
                                            {...params} />}
                                    />
                                </Stack>
                            </LocalizationProvider>
                        </Col>
                        <Col xs={12}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <Stack spacing={3}>
                                    <MobileDatePicker
                                        label="Tanggal Mulai"
                                        renderInput={(params) => <TextField
                                            size="small"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            error={this.hasError('tgl_mulai')}
                                            helperText={
                                                this.hasError('tgl_mulai') ? errors.tgl_mulai[0] : null
                                            }
                                            {...params} />}
                                        value={values.tgl_mulai || null}
                                        onChange={(newValue) => {
                                            this.handleChangeSetValue("tgl_mulai", newValue)
                                        }}

                                    />
                                </Stack>
                            </LocalizationProvider>
                        </Col>
                        <Col xs={12}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <Stack spacing={3}>
                                    <MobileDatePicker
                                        label="Tanggal Selesai"
                                        renderInput={(params) => <TextField
                                            size="small"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            error={this.hasError('tgl_selesai')}
                                            helperText={
                                                this.hasError('tgl_selesai') ? errors.tgl_selesai[0] : null
                                            }
                                            {...params} />}
                                        value={values.tgl_selesai || null}
                                        onChange={(newValue) => {
                                            this.handleChangeSetValue("tgl_selesai", newValue)
                                        }}

                                    />
                                </Stack>
                            </LocalizationProvider>
                        </Col>
                    </Row>
                </Col>
                <Col xs={10}>
                    <Row gutter={[16, 16]}>
                        <Col xs={24}>
                            <TextField
                                fullWidth
                                label="Nomor Sertifikat"
                                size="small"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                name="nomor_sertifikat"
                                type="text"
                                onChange={this.handleChange}
                                value={values.nomor_sertifikat || ''}
                                error={this.hasError('nomor_sertifikat')}
                                helperText={
                                    this.hasError('nomor_sertifikat') ? errors.nomor_sertifikat[0] : null
                                }
                            />
                        </Col>
                        <Col xs={24}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <Stack spacing={3}>
                                    <MobileDatePicker
                                        label="Tanggal Sertifikat"
                                        renderInput={(params) => <TextField
                                            size="small"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            error={this.hasError('tgl_sertifikat')}
                                            helperText={
                                                this.hasError('tgl_sertifikat') ? errors.tgl_sertifikat[0] : null
                                            }
                                            {...params} />}
                                        value={values.tgl_sertifikat || null}
                                        onChange={(newValue) => {
                                            this.handleChangeSetValue("tgl_sertifikat", newValue)
                                        }}
                                    />
                                </Stack>
                            </LocalizationProvider>
                        </Col>
                        <Col xs={24}>
                            <Dragger
                                action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                fileList={this.state.fileList}
                                onChange={this.handleChangeFile}
                                beforeUpload={this.beforeUploadFile}
                                maxCount={1}
                            >
                                <p className="ant-upload-drag-icon">
                                    <InboxOutlined />
                                </p>
                                <p className="ant-upload-text">Klik atau seret file ke area ini</p>
                                <p className="ant-upload-hint">File yang diperbolehkan untuk diunggah: JPG, PNG & PDF</p>
                                <p className="ant-upload-hint">File yang diperbolehkan maksimal 2MB</p>
                            </Dragger>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Modal>

        return (
            <>
                <PageHeader
                    className="site-page-header"
                    title="Pelatihan"
                    extra={
                        <>
                            {/* <Button type="text"><Link to={`/tenaga-kependidikan/guru`}>Kembali</Link></Button> */}
                            <Tooltip title="Tambah">
                                <Button type='primary' icon={<PlusOutlined />} onClick={this.showModalForm}> Tambah</Button>
                            </Tooltip>
                        </>
                    }

                />
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={21}>
                        <Input
                            name="search"
                            className='search-table'
                            placeholder="Search..."
                            prefix={<SearchOutlined className="site-form-item-icon" />}
                            onChange={(e) => {
                                const params = getParamTable("search", table, e.target.value)
                                this.fetch(params)
                            }}
                            value={table.search || ""}
                            suffix={
                                <Tooltip title="Cari berdasarkan nama">
                                    <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                </Tooltip>
                            }
                        />
                    </Col>
                    <Col xs={24} sm={3}>
                        <Button.Group className='ant-btn-group-fullwidth'>
                            <Popover placement="bottom" content={sortComponent} trigger="click">
                                <Button block className='btn-border-radius-right'><SortAscendingOutlined /> Sort</Button>
                            </Popover>
                        </Button.Group>
                    </Col>

                </Row>

                <Divider orientation="left"></Divider>

                <Row>
                    <Col span={24}>
                        <Table
                            columns={[
                                {
                                    title: 'No',
                                    dataIndex: 'rownum',
                                    width: '3%',
                                },
                                {
                                    title: 'Nama Pelatihan',
                                    dataIndex: 'nama',
                                },
                                {
                                    title: 'Bidang Pelatihan',
                                    dataIndex: 'bidang',
                                },
                                {
                                    title: 'Penyelenggara',
                                    dataIndex: 'penyelenggara',
                                },
                                {
                                    title: 'Tahun',
                                    dataIndex: 'tahun',
                                },
                                {
                                    title: 'Tanggal Mulai',
                                    dataIndex: 'tgl_mulai',
                                },
                                {
                                    title: 'Tanggal Selesai',
                                    dataIndex: 'tgl_selesai',
                                },
                                {
                                    title: 'Sertifikat',
                                    dataIndex: 'sertifikat',
                                    render: (a, row) => row.file ? <a target="_blank" rel="noopener noreferrer" href={row.main_path + row.file} style={{ fontSize: 11 }}>Download <DownloadOutlined /></a> : "-",
                                },
                                {
                                    title: <EllipsisOutlined />,
                                    align: "center",
                                    key: 'operation',
                                    width: '2%',
                                    render: (a, row) => <Dropdown trigger={['click']} menu={{
  items: [{
    key: 0,
    icon: <EditOutlined />,
    label: "Update",
    onClick: this.showModalForm.bind(this, row)
  }, {
    key: 1,
    icon: <DeleteOutlined />,
    label: "Delete",
    onClick: this.onDelete.bind(this, row)
  }]
}}>
                                        <div className="ant-dropdown-link tb-action">
                                            <Button type='primary'>Opsi</Button>
                                        </div>
                                    </Dropdown>,
                                },
                                {
                                    title: 'LogActivity',
                                    key: 'operation',
                                    width: '10%',
                                    render: (a, row) => _tableLogActivity(row),
                                },
                            ]}
                            rowKey={record => record.id}
                            dataSource={table.data}
                            pagination={table.pagination}
                            loading={table.loading}
                            onChange={(pagination) => {
                                const params = getParamTable("change", table, null, null, pagination)
                                this.fetch(params)
                            }}
                            size="small"
                        />
                    </Col>
                </Row>
                {modalForm}
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        privilege: state.privilege,
    }
}

export default connect(mapStateToProps)(Pelatihan);
